import { formatISO } from 'date-fns';

import { HistoryDatepickerWithModal } from 'reusable/historyDatepickerWithModal/HistoryDatepickerWithModal';
import { TableSearchContainer } from 'reusable/tableSearch/TableSearchContainer';
import { HistoryActionAutocomplete } from 'reusable/historyActionAutocomplete/HistoryActionAutocomplete';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { UsersLoginHistoryQuery } from 'context/query/queryContext/QueryContext.types';
import { QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';

import { UsersLoginHistoryFiltersProps } from './UsersLoginHistoryFilters.types';

export const UsersLoginHistoryFilters = ({ userSearchQuery, setUserSearchQuery }: UsersLoginHistoryFiltersProps) => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { usersLoginHistory: usersLoginHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const setHistoryQuery = (query: UsersLoginHistoryQuery) => {
    setQuery(QueryKeyLocalStorageEnum.USERS_LOGIN_HISTORY, { ...usersLoginHistoryQuery, ...query });
  };

  return (
    <>
      <HistoryDatepickerWithModal
        dates={[
          usersLoginHistoryQuery.dataOd ? new Date(usersLoginHistoryQuery.dataOd) : null,
          usersLoginHistoryQuery.dataDo ? new Date(usersLoginHistoryQuery.dataDo) : null,
        ]}
        setDates={(dates) =>
          setHistoryQuery({
            dataOd: dates[0] ? formatISO(dates[0]) : undefined,
            dataDo: dates[1] ? formatISO(dates[1]) : undefined,
          })
        }
      />

      <HistoryActionAutocomplete
        selectedAction={usersLoginHistoryQuery.akcja}
        onChangeAction={(action) => setHistoryQuery({ akcja: action })}
        historyType="usersLogin"
      />

      <TableSearchContainer
        withoutToggle
        inputPlaceholder={formatMessage({ id: AppMessages['users.loginHistory.searchPlaceholder'] })}
        searchBy="users"
        tableSearchQuery={userSearchQuery}
        setTableSearchQuery={setUserSearchQuery}
        selectedValue={usersLoginHistoryQuery.query}
        setSelectedValue={(option) => setHistoryQuery({ query: option || undefined })}
        inputSize="big"
      />
    </>
  );
};
